// extracted by mini-css-extract-plugin
module.exports = {"ipt":"ipt-1UhKJDch","bar":"bar-2TkMunjF"};